import { render, staticRenderFns } from "./BipSchools2.vue?vue&type=template&id=03c9aa8e&scoped=true&"
import script from "./BipSchools2.vue?vue&type=script&lang=js&"
export * from "./BipSchools2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c9aa8e",
  null
  
)

export default component.exports